import { Option } from '../types/common-types'
import { FoundingDocument } from '../enums/foundingDocumentEnum'

export const foundingDocumentOptions: Option[] = [
  // {
  //   value: '1',
  //   label: {
  //     eng: 'Order',
  //     rus: 'Приказ',
  //     kz: 'Бұйрық',
  //   },
  // },
  // {
  //   value: '5',
  //   label: {
  //     eng: 'Minutes',
  //     rus: 'Протокол',
  //     kz: 'Хаттама',
  //   },
  // },
  {
    value: FoundingDocument.Charter,
    label: {
      eng: 'The Charter of the Organization',
      rus: 'Устав',
      kz: 'Жарғы',
    },
    description: {
      eng: 'This option should be selected if the current leader will personally sign the contract with our company.',
      rus: 'Пожалуйста, выберите этот вариант, если договор с нашей компанией будет подписан лично руководителем.',
      kz: 'Егер біздің компаниямен келісім-шартқа басшының өзі қол қойса, осы опцияны таңдаңыз.' },
  },
  {
    value: FoundingDocument.PowerOfAttorney,
    label: { eng: 'The Power of Attorney', rus: 'Доверенность', kz: 'Сенімхат' },
    description: {
      eng: 'This option should be selected if the contract will be signed by someone who has authority based on a power of attorney.',
      rus: 'В случае подписания договора с нашей компанией уполномоченным лицом, действующим на основании доверенности, необходимо выбрать данный вариант.',
      kz: 'Сенімхат негізінде әрекет ететін уәкілетті тұлға біздің компаниямен шартқа қол қойған жағдайда, осы нұсқаны таңдау қажет.' },
  },
]
